import React from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import DialogHeader from '../basic/DialogHeader';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = (theme) => ({
    dialogContentScroll: {
        overflowY: 'auto',
    },
    dialogContent: {
        maxHeight: 'unset',
    },
});

class DialogInput extends React.Component {
    state = {
        open: false
    };

    render() {
        const { classes } = this.props;
        const p = this.props;
        let dialogStyles = {
            maxWidth: 'unset',
            position: 'absolute',
            ...p.style
        };
        return (
            <Dialog
                sx={{
                    '& .MuiDialog-paper': {
                        ...dialogStyles
                    },
                }}
                className={`dialog ${p.className}`}
                open={p.open}
                onClose={p.handleClose}
                disableEscapeKeyDown={p.model}
                BackdropProps={{
                    onClick: (e) => {
                        if (p.model) {
                            e.stopPropagation()
                        }
                    }
                }}
            >
                {p.title}
                {/*<DialogTitle*/}
                {/*    sx={{*/}
                {/*        display: 'flex',*/}
                {/*        justifyContent: 'space-between',*/}
                {/*        alignItems: 'center',*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <DialogHeader*/}
                {/*        text= {p.title}*/}
                {/*    />*/}
                {/*    {  p.handleClose && <IconButton*/}
                {/*        aria-label="close"*/}
                {/*        onClick={() => {*/}
                {/*            p.handleClose();*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <CloseIcon />*/}
                {/*    </IconButton>}*/}
                {/*</DialogTitle>*/}
                <DialogContent
                    tabIndex={0}
                    ref={p.ref && p.ref}
                    onKeyDown={p.onKeyDown && p.onKeyDown}
                >
                    {p.children}
                </DialogContent>
                {p.actions && <DialogActions>
                    {p.actions}
                </DialogActions>}
            </Dialog>
        );
    }
}
export default withStyles(useStyles)(DialogInput);
